<template>
  <template v-if="isLogged">
    <header :class="{ 'header-main': true, 'fixed': isFixed, 'logged': isLogged, style }" v-show="!isLogged || isLogged">
      <nav>
        <ul>
            <li class="main-menu breadcrumb">
              <menu>
                <ul v-if="showMenu">
                    <li v-for="(crumb, index) in breadcrumb" :key="index" :class="{ actived: index === breadcrumb.length - 1 }">
                      <RouterLink :to="crumb.path">{{ crumb.title }}</RouterLink>
                    </li>
                </ul>
              </menu>
            </li>
            <li class="separator"></li>
            <li class="search" :class="{ 'active': isActiveSearch }" ref="search">
              <a href="#pesquisar" class="btn big transparent icon" @click.prevent="openSearch"><i class="bi bi-search"></i><!--<small>Pesquisar</small>--></a>
              <InputField type="text" name="search" placeholder="Cursos, aulas ou professores" class="no-margin small has-icon color-light" />
            </li>
            <li class="notification hasmenu" :class="{ 'active': isActiveNotificationMenu }" ref="notificationMenu">
              <a href="#notificacoes" class="btn big transparent icon" @click.prevent="toggleNotificationMenu"><i class="bi bi-bell"></i></a>
              <span class="menu">
                <ul>
                  <li>Não há notificações</li>
                </ul>
              </span>
            </li>
            <li class="theme hasmenu">
                <a href="#tema" class="btn big transparent icon" @click.prevent="toggleTheme" title="Alterar tema">
                  <i :class="theme === 'dark' ? 'bi bi-moon' : 'bi bi-sun'"></i>
                </a>
            </li>
            <li class="account hasmenu" :class="{ 'active': isActiveAccountMenu }" ref="accountMenu">
              <a href="#conta" class="avatar" :style="!avatarImage ? { backgroundColor: avatarColor } : {}" @click.prevent="toggleAccountMenu">
                {{ userInfo.firstLetter }}
                <span v-if="avatarImage" class="image" :style="{ backgroundImage: `url(${avatarImage})` }"></span>
              </a>
              <span class="menu">
                <ul>
                  <li class="account-title"><span href="#conta" class="avatar" :style="!avatarImage ? { backgroundColor: avatarColor } : {}">
                    {{ userInfo.firstLetter }}
                    <span v-if="avatarImage" class="image" :style="{ backgroundImage: `url(${avatarImage})` }"></span>
                  </span> {{ userInfo.name }}</li>
                    <li><RouterLink to="/meus-itens/">Meus Itens</RouterLink></li>
                    <li><RouterLink to="/ajuste-de-perfil/">Ajuste de Perfil</RouterLink></li>
                    <li><RouterLink to="/configuracoes/">Configurações</RouterLink></li>
                    <li class="exit"><RouterLink to="/logout/">Sair</RouterLink></li>
                </ul>
              </span>
            </li>
        </ul>
      </nav>
    </header>
  </template>
</template>

<script>
import { getUserInfo } from '@/store/authService';
export default {
  props: {
    showMenu: {
      type: Boolean,
      default: true,
    },
    isLogged: {
      type: Boolean,
      default: true,
    },
    style: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // isFixed: false,
      isFixed: true,
      isActiveAccountMenu: false,
      isActiveNotificationMenu: false,
      isActiveSearch: false,
      currentRoute: this.$route.path,
      pageTitle: this.$route.meta.title,
      userInfo: {},
      theme: 'dark',
      breadcrumb: [],
      avatarImage : null,
      avatarColor : '#111',
    };
  },
  watch: {
    // Watch for route changes and update breadcrumb data
    $route(to) {
      this.userInfo = getUserInfo();
      this.isActiveAccountMenu = false;
      this.isActiveNotificationMenu = false;
      this.currentRoute = to.path;
      this.pageTitle = to.meta.title || '';
      this.buildBreadcrumb();
    },
    userInfo: {
      handler(newVal) {
        this.avatarImage = newVal.image || null;
        this.buildColor();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    document.addEventListener('click', this.handleOutsideMenuClick);
    this.theme = localStorage.getItem('theme') || 'dark';
    this.userInfo = getUserInfo();
    this.buildBreadcrumb();
  },
  beforeUnmount() {
    // window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener('click', this.handleOutsideMenuClick);
    // console.log('remove event listener');
  },
  methods: {
    buildColor() {
      if (!this.userInfo || !this.userInfo.name) {
        this.avatarColor = '#111';
        return;
      }
      const name = this.userInfo.name;
      // Simple hash function to generate a number from the name
      function hashCode(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
      }
      // Generate HSL color from hash
      function nameToColor(name) {
        const hash = hashCode(name);
        const hue = Math.abs(hash) % 360;
        // You can tweak saturation and lightness for different palettes
        return `hsl(${hue}, 60%, 50%)`;
      }
      this.avatarColor = nameToColor(name);
    },
    buildBreadcrumb() {
      this.breadcrumb = [];
      if (this.$route.matched.length > 0) {
        this.$route.matched.forEach((route) => {
          if (!this.breadcrumb.some((crumb) => crumb.path === route.path)) {
            this.breadcrumb.push({
              path: route.path,
              title: route.meta?.title || 'Home',
            });
          }
        });
      }
      // console.log('Breadcrumb:', this.breadcrumb);
    },
    // handleScroll() {
    //   var header = document.querySelector("header");
    //   this.isFixed = window.scrollY > 0;
    //   if (this.isFixed) {
    //     header.classList.add("fixed");
    //   } else {
    //     header.classList.remove("fixed");
    //   }
    // },
    openSearch() {
      this.isActiveSearch = true;
      const searchDiv = this.$refs.search;
      const inputElement = searchDiv.querySelector('input');
      if (inputElement) {
        inputElement.focus();
      }
    },
    toggleAccountMenu() {
      this.isActiveAccountMenu = !this.isActiveAccountMenu;
    },
    toggleNotificationMenu() {
      this.isActiveNotificationMenu = !this.isActiveNotificationMenu;
    },
    handleOutsideMenuClick(event) {
      const elementsToToggle = [
        { ref: 'accountMenu', state: 'isActiveAccountMenu' },
        { ref: 'notificationMenu', state: 'isActiveNotificationMenu' },
      ];
      elementsToToggle.forEach(({ ref, state }) => {
        const element = this.$refs[ref];
        if (element && !element.contains(event.target)) {
          this[state] = false;
        }
      });
      if(this.isActiveSearch){
        const searchElement = this.$refs.search;
        if (searchElement && !searchElement.contains(event.target)){
          const searchDiv = this.$refs.search;
          const inputElement = searchDiv.querySelector('input');
          if (inputElement && !inputElement.value.trim()) {
            this.isActiveSearch = false;
          }
        }
      }
    },
    toggleTheme() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark';
      document.body.classList.toggle('light', this.theme === 'light');
      localStorage.setItem('theme', this.theme);
    },
  },
};
</script>

<style scoped src="@/assets/css/header-style.css"></style>
